/**
 * Reducer for guest board experience
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Yucho Ho
 */
import produce from 'immer'
import moment from 'moment'
import { nestReducers } from 'client/shared/js/utils/reducer'
import { bindSelectors } from 'client/shared/js/utils/selector'
import listPlacesReducer, { selectors as listPlacesSelectors } from './listPlaces'
import { GUEST_CREATE_BOARD, GUEST_EDITING_BOARD } from '../types'

const initialState = {
  rid: 'guest-reducer'
}

// ------------------------------------
// Reducer
// ------------------------------------
const guestReducer = produce((draft, action) => {
  switch (action.type) {
    case GUEST_CREATE_BOARD:
      return initialState

    case GUEST_EDITING_BOARD:
      // Reset the persist counter when users visit the guest board
      draft['__persisted_at'] = moment.now()
      break
  }
}, initialState)

export default nestReducers(guestReducer, {
  listPlaces: listPlacesReducer
})

const selectGuestListPlaces = (state) => {
  return state.listPlaces
}

export const selectors = {
  selectGuestListPlaces,
  ...bindSelectors(selectGuestListPlaces, listPlacesSelectors)
}
